<!--The content below is only a placeholder and can be replaced.-->
<router-outlet (activate)="onActivate($event)" ></router-outlet>
